<template>
    <div class="_self_address_select">
        <div :style="{width:inputWidth,display:'inline-block'}" :class="getIndexClass(index)" v-for="(item,index) in addressList">
            <FormItem :prop="rules[index]" :style="{width:'100%'}">
                <label slot="label" v-if="(index===0 && title!==' ')" v-html="title"></label>
                <label slot="label" v-else>&nbsp;</label>
                <Select v-model="defaultSelect[index]" placeholder="请选择" @on-change="getAddressList(defaultSelect[index],index)">
                    <Option v-for="vo in addressList[index]" :value="vo.id" :key="vo.id" :label="vo.name"></Option>
                </Select>
            </FormItem>
        </div>
    </div>
</template>

<script>
    import $api from "@/service/index";
    export default {
        props:{
            rules:Array,
            //标题
            title : String,
            //input宽度
            inputWidth : String,
            //默认选中的值
            defaultOptions : Array,
            //是否包含全部选项
            all:Boolean,
            //几级联动
            level:Number
        },
        data(){
            return {
                defaultSelect:[],
                addressList : [],
                //2019-08-05 继承权限 直辖市二级不显示全部 定义一个过滤用的数组
                specialCityArray : ['1x','2x','9x','22x']
            }
        },
        created(){
            this.getAddressList("0",0,1);
            for(let i=1;i<this.level;i++){
                let opt = this.defaultOptions[i-1] ;
                this.getAddressList(opt,i,1);
            }
        },
        mounted(){

        },
        methods : {
            /**
             * 获取备选项
             * @param {string} pid 父级id
             * @param {int} i 单签项索引
             * @param {init} init 是否初始化
             * @returns {boolean}
             */
            getAddressList(pid,i,init=0){
                let _self = this;
                if(pid === ""){
                    _self.addressList[i] = [
                        {'id': '0', 'fid': '0', 'name': '全部', 'type': '1'},
                    ];
                    return false;
                }
                if(!pid || pid ===0 ){
                    pid = "0";
                }
                if(init === 0){
                    i = i+1;
                }
                if(i+1 > _self.level){
                    this.$emit('refreshData');
                    return false;
                }
                _self.addressList[i] = [];
                let f = true;
                if((pid === "0" && i >1)){
                    f = false
                }
                //axios
                $api.getAddressList(pid).then(data=>{
                    if(this.all === true){
                        if(this.specialCityArray.indexOf(pid) === -1){
                            _self.addressList[i] = [
                                {'id': '0', 'fid': '0', 'name': '全部', 'type': '1'},
                            ];
                        }
                    }
                    if(f===true && !(pid === "0"&&init===0&&i===1)){
                        _self.addressList[i] = _self.addressList[i].concat(data);
                    }
                    if(init === 1){
                         _self.defaultSelect = [].concat(_self.defaultOptions);
                    }else{
                        for(let k=i;k<_self.level;k++) {
                            _self.defaultSelect.splice(k, 1, "");
                        }
                    }
                });
                //刷新父组件中的数据
                this.$emit('refreshData');
            },
            //获取选中项
            getSelect(){
                return this.defaultSelect;
            },
            /**
             * 根据索引获取class
             * @param {int} index 索引
             * @returns {string}
             */
            getIndexClass(index){
                let str = " ";
                switch(index){
                    case 0 :
                        return "one ";
                    case 1:
                        return "two ";
                    case 2:
                        if(this.level == 3){
                            return "three ";
                        }
                        return "two ";
                    case 3:
                        return "three ";
                    default:
                        break;
                }
            }
        },
    }
</script>

<style scoped>
    
</style>
<style>
    ._self_address_select .ivu-form-item-label{
        min-height: 22px;
    }
    ._self_address_select div:not(:first-child) .ivu-form-item-required .ivu-form-item-label:after{
        color:rgba(0,0,0,0) !important;
    }
    ._self_address_select .ivu-select-selection{
        /*border-radius: 0;*/
    }

    ._self_address_select .one .ivu-select-selection{
        margin-right:5px;
    }
    ._self_address_select .two .ivu-select-selection{
        margin: 0 5px;
    }
    ._self_address_select .three .ivu-select-selection{
        margin-left: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/addressSelect/AddressSelect.vue